/* ============================= */
/* VERSION V1.2 - ANALYTICS.JS */
/* ============================= */

export const trackEvent = (eventName, params = {}) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  };

